/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { SchedulePlanSessionFragmentDoc, ScheduleProjectFragmentDoc, ScheduleWhoFragmentDoc } from '../../../features/schedule/Fragments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DashboardPersonalCalendarQueryVariables = Types.Exact<{
  rangeStart?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  rangeEnd?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  userId: Types.Scalars['ID']['input'];
}>;


export type DashboardPersonalCalendarQuery = { planSessions: { __typename: 'MissingCapabilities' } | { __typename: 'PlanSessionConnection', edges: Array<{ __typename: 'PlanSessionEdge', node: { __typename: 'PlanSession', id: string, from: any, till: any, isTentative: boolean, roles: Array<{ __typename: 'ProjectRole', internalName: string, label: string, id: string }>, who: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, project: { __typename: 'Project', id: string, title: string, ticket: boolean, earliestStart?: any | null, deadline?: any | null, viewerPermissions: Array<Types.PermissionName>, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null } } }> } };


export const DashboardPersonalCalendarDocument = gql`
    query DashboardPersonalCalendar($rangeStart: DateTime, $rangeEnd: DateTime, $userId: ID!) {
  planSessions(
    limit: 0
    filters: {rangeStart: $rangeStart, rangeEnd: $rangeEnd, whoIds: [$userId]}
  ) {
    ... on PlanSessionConnection {
      edges {
        node {
          id
          ...SchedulePlanSession
        }
      }
    }
  }
}
    ${SchedulePlanSessionFragmentDoc}`;

/**
 * __useDashboardPersonalCalendarQuery__
 *
 * To run a query within a React component, call `useDashboardPersonalCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPersonalCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardPersonalCalendarQuery({
 *   variables: {
 *      rangeStart: // value for 'rangeStart'
 *      rangeEnd: // value for 'rangeEnd'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDashboardPersonalCalendarQuery(baseOptions: Apollo.QueryHookOptions<DashboardPersonalCalendarQuery, DashboardPersonalCalendarQueryVariables> & ({ variables: DashboardPersonalCalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardPersonalCalendarQuery, DashboardPersonalCalendarQueryVariables>(DashboardPersonalCalendarDocument, options);
      }
export function useDashboardPersonalCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardPersonalCalendarQuery, DashboardPersonalCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardPersonalCalendarQuery, DashboardPersonalCalendarQueryVariables>(DashboardPersonalCalendarDocument, options);
        }
export function useDashboardPersonalCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardPersonalCalendarQuery, DashboardPersonalCalendarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardPersonalCalendarQuery, DashboardPersonalCalendarQueryVariables>(DashboardPersonalCalendarDocument, options);
        }
export type DashboardPersonalCalendarQueryHookResult = ReturnType<typeof useDashboardPersonalCalendarQuery>;
export type DashboardPersonalCalendarLazyQueryHookResult = ReturnType<typeof useDashboardPersonalCalendarLazyQuery>;
export type DashboardPersonalCalendarSuspenseQueryHookResult = ReturnType<typeof useDashboardPersonalCalendarSuspenseQuery>;
export type DashboardPersonalCalendarQueryResult = Apollo.QueryResult<DashboardPersonalCalendarQuery, DashboardPersonalCalendarQueryVariables>;